import React, { useState } from 'react'
import { Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import type { LinkProps } from 'react-router-dom'
import '../../styles/flagTooltip.css'

type TruncatedTextProps = {
  text: string
  // Om satt renderas texten som en länk (namn/avvikelse); annars ren text (t.ex. personnummer).
  to?: LinkProps['to']
  linkId?: string
  // Körs vid klick på länken, före navigeringen (t.ex. sätta ansvarig person i Redux innan
  // Mina ärenden öppnas). Endast relevant tillsammans med `to`.
  onClick?: () => void
}

const ellipsisStyle: React.CSSProperties = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  // Lite luft mellan "…" och cellens slut.
  paddingRight: 5,
  boxSizing: 'border-box',
}

// Avkortar på FAKTISK bredd (cellbredden, via CSS-ellipsis) och visar hela texten i en
// flag-tooltip ENDAST när den är klippt. "Klippt?" mäts på hover (scrollWidth > clientWidth)
// via e.currentTarget — en cell i taget, ingen render-mätning/observer → ingen perf-kostnad.
const TruncatedText: React.FC<TruncatedTextProps> = ({ text, to, linkId, onClick }) => {
  const [truncated, setTruncated] = useState(false)
  const measure = (e: React.MouseEvent<HTMLSpanElement>) => {
    const el = e.currentTarget
    setTruncated(el.scrollWidth > el.clientWidth)
  }
  const label = (
    <span onMouseEnter={measure} style={ellipsisStyle}>
      {text}
    </span>
  )
  const inner = to ? (
    <Link to={to} id={linkId} onClick={onClick} style={{ display: 'block' }}>
      {label}
    </Link>
  ) : (
    label
  )
  return (
    <Tooltip title={truncated ? text : ''} overlayClassName="flag-tooltip" placement="topLeft">
      {inner}
    </Tooltip>
  )
}

export default TruncatedText
